export default __webpack_public_path__ + "static/blurred_reviews-f9da7cf50b206acee72994eae8a395df.png";